const reviewsActionTypes = {
  GET_REVIEWS_START: 'GET_REVIEWS_START',
  GET_REVIEWS_SUCCESS: 'GET_REVIEWS_SUCCESS',
  GET_REVIEWS_FAILURE: 'GET_REVIEWS_FAILURE',

  GET_USER_REVIEWS_START: 'GET_USER_REVIEWS_START',
  GET_USER_REVIEWS_SUCCESS: 'GET_USER_REVIEWS_SUCCESS',
  GET_USER_REVIEWS_FAILURE: 'GET_USER_REVIEWS_FAILURE',

  GET_PRODUCT_REVIEWS_START: 'GET_PRODUCT_REVIEWS_START',
  GET_PRODUCT_REVIEWS_SUCCESS: 'GET_PRODUCT_REVIEWS_SUCCESS',
  GET_PRODUCT_REVIEWS_FAILURE: 'GET_PRODUCT_REVIEWS_FAILURE',
};

export default reviewsActionTypes;
